module.exports = __webpack_public_path__ + "img/xlouisiana_logo.png.pagespeed.ic.xs0OvT1C9t-Copy.a6b9024e.png";